import { Component, OnInit } from "@angular/core";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";

import { Router } from "@angular/router";
import { NzModalService, UploadXHRArgs, NzMessageService } from "ng-zorro-antd";
import { AuthenticationService } from "@app/core/services/ats/authentication.service";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { DatePipe } from "@angular/common";
import { UIUtil } from "@app/core/utils/ui.util";
import { phoneNumberValidator, agencyValidator } from "./cValidator";
import { Authetication, session_keys } from "@app/core";
import { DomSanitizer } from "@angular/platform-browser";
import { DashboardService } from "@app/core/services/ats/dashboard.service";
@Component({
  selector: "app-view",
  templateUrl: "./view.component.html",
  styleUrls: ["./view.component.scss"],
  providers: [DatePipe],
})
export class ViewComponent implements OnInit {
  amount = 0;
  listofbills = [
    {
      key_name: "Application Fees",
      key_value: {
        source: "1.0",
        parsedValue: 1,
      },
    },
    {
      key_name: "GST (18%)",
      key_value: 0.18,
    },
  ];
  private globalConfig: any;
  payment = false;
  paymentscreen = false;
  is_bgv_in_registration=true;
  offerletterProvisionModel = {
    isVisible: false,

    pdf: null,
  };
  pdfn = true;
  empname = "";
  campusdata = [];
  userId = JSON.parse(localStorage.getItem("PRIVATE_KEY")).userId;
  is_latral = JSON.parse(localStorage.getItem("PRIVATE_KEY")).is_latral;
  current = 0;
  collegeName;
  proceedtopayButton = true;
  collegeAddress = "";
  date;
  dob;
  nationality;
  martialS;
  yearPass;
  sucess = false;
  name;
  gender;
  pAddress;
  course;
  spining = false;
  fatherName;
  unniname;
  unniAddress;
  al_email;
  public presentAddress: FormGroup;
  public academicForm: FormGroup;
  referalFormGroup: FormGroup;
  public employerForm: FormGroup;
  id;
  courseType = "";
  userDetails: any = {};
  loginid;
  jobid;
  constructor(
    private message: NzMessageService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private datePipe: DatePipe,
    public fb: FormBuilder,
    public sanitiser: DomSanitizer,
    private modalService: NzModalService,
    private dashboardService: DashboardService,
  ) {
    this.userDetails = UIUtil.getPrivateData(session_keys.private_key);
    this.loginid = this.userDetails.vendor;
    this.presentAddress = this.fb.group({
      room: ["", Validators.required],
      local: ["", Validators.required],
      street: ["", Validators.required],
      pincode: [
        "",
        [Validators.required, Validators.max(999999), Validators.min(99999)],
      ],
      state: ["", Validators.required],
      cphone: [""],
      alcontact: [""],
      district: ["", Validators.required],

      landmark: ["", Validators.required],
      stayDur: ["", Validators.required],
      pStay: ["", Validators.required],
      pNumber: ["", phoneNumberValidator],
      palNumber: ["", phoneNumberValidator],
      pLandmark: ["", Validators.required],
    });

    this.academicForm = this.fb.group({
      courseType: ["", Validators.required],
      unniAddress: ["", Validators.required],
    });
    this.getCandidateData(this.loginid);
    this.employerForm = this.fb.group({
      empName: ["", Validators.required],
      empCode: ["", Validators.required],
      empFrom: ["", Validators.required],
      empTo: ["", Validators.required],
      empAdd: ["", Validators.required],
      reasonLeaving: ["", Validators.required],
      department: ["", Validators.required],
      designation: ["", Validators.required],
      salary: ["", Validators.required],
      posType: ["", Validators.required],
      agencyDetails: ["", agencyValidator],
      hrName: ["", Validators.required],
      hrNumber: ["", phoneNumberValidator],
      hrEmail: ["", [Validators.required, Validators.email]],
    });

    this.referalFormGroup = this.fb.group({
      referencename1: [
        "",
        [
          Validators.maxLength(100),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      referencenumber1: ["", [phoneNumberValidator, Validators.required]],
      referenceemail1: [
        "",
        [
          Validators.maxLength(50),
          Validators.pattern(
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b$/,
          ),
        ],
      ],

      r1roomnumber: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],
      r1premisename: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],
      r1streetname: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      r1state: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      r1pincode: [
        "",
        [Validators.max(999999), Validators.min(99999), Validators.required],
      ],
      r1district: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      referencename2: [
        "",
        [
          Validators.maxLength(100),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      referencenumber2: ["", [phoneNumberValidator, Validators.required]],
      referenceemail2: [
        "",
        [
          Validators.maxLength(50),
          Validators.pattern(
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b$/,
          ),
        ],
      ],

      r2roomnumber: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],
      r2premisename: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],
      r2streetname: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      r2state: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      r2pincode: [
        "",
        [Validators.max(999999), Validators.min(99999), Validators.required],
      ],
      r2district: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      referencename3: [
        "",
        [
          Validators.maxLength(100),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      referencenumber3: ["", [phoneNumberValidator, Validators.required]],
      referenceemail3: [
        "",
        [
          Validators.maxLength(50),
          Validators.pattern(
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b$/,
          ),
        ],
      ],
      r3roomnumber: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],
      r3premisename: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],
      r3streetname: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      r3state: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],

      r3pincode: [
        "",
        [Validators.max(999999), Validators.min(99999), Validators.required],
      ],
      r3district: [
        "",
        [
          Validators.maxLength(50),
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/),
        ],
      ],
    });

    this.employerForm.controls.posType.valueChanges.subscribe((x) =>
      this.employerForm.controls.agencyDetails.updateValueAndValidity(),
    );
  }

  ngOnInit() {
    //console.log(this.userId);
    this.date = new Date();
  }
  next() {
    if (this.current === 0) {
      if (this.presentAddress.valid) {
        this.current++;
        return;
      } else {
        Object.keys(this.presentAddress.controls).forEach((key) => {
          this.presentAddress.controls[key].markAsDirty();
        });
      }
    }

    if (this.current === 1) {
      if (this.empname !== "" && this.empname !== null) {
        if (this.checkacademics()) {
          this.current = 2;
          return;
        } else {
          this.message.warning("Please fill all the fields");
          return;
        }
      } else {
        if (this.checkacademics()) {
          this.current = 3;
          return;
        } else {
          this.message.warning("Please fill all the fields");
          return;
        }
      }
      //alert(this.academicForm.get('unniAddress').value);
      // console.log(this.academicForm.get('courseType').value);

      // if(this.academicForm.valid){
      //   this.current++;
      //   return;
      // }
      // else {
      //   Object.keys(this.academicForm.controls).forEach(key=>{
      //     this.academicForm.controls[key].markAsDirty();
      //   })
      // }
    }
    if (this.current === 2) {
      if (
        this.employerForm.controls["empCode"].value !== null &&
        this.employerForm.controls["empCode"].value !== "" &&
        this.employerForm.controls["empAdd"].value !== null &&
        this.employerForm.controls["empAdd"].value !== "" &&
        this.employerForm.controls["department"].value !== null &&
        this.employerForm.controls["department"].value !== "" &&
        this.employerForm.controls["posType"].value !== null &&
        this.employerForm.controls["posType"].value !== "" &&
        this.employerForm.controls["hrName"].value !== null &&
        this.employerForm.controls["hrName"].value !== "" &&
        this.employerForm.controls["hrNumber"].value !== null &&
        this.employerForm.controls["hrNumber"].value !== "" &&
        this.employerForm.controls["hrEmail"].value !== null &&
        this.employerForm.controls["hrEmail"].value !== ""
      ) {
        this.current = 3;
        return;
      } else {
        this.message.warning("Please fill all the fields");
        return;
      }
      //   if(this.employerForm.valid){
      //     this.current++;
      //     return;
      //   }
      //   else {
      //     Object.keys(this.employerForm.controls).forEach(key=>{
      //       this.employerForm.controls[key].markAsDirty();
      //     })
      //   }

      //   if(this.employerForm.valid){
      //     this.current++;
      //     return;
      //   }
      //   else {
      //     Object.keys(this.employerForm.controls).forEach(key=>{
      //       this.employerForm.controls[key].markAsDirty();
      //     })
      //   }

      // }
    }
    if (this.current === 3) {
      if (this.referalFormGroup.valid) {
        this.current++;
        return;
      } else {
        Object.keys(this.referalFormGroup.controls).forEach((key) => {
          this.referalFormGroup.controls[key].markAsDirty();
        });
      }

      //   if(this.employerForm.valid){
      //     this.current++;
      //     return;
      //   }
      //   else {
      //     Object.keys(this.employerForm.controls).forEach(key=>{
      //       this.employerForm.controls[key].markAsDirty();
      //     })
      //   }

      // }
    }
  }
  prev() {
    if (this.current === 3) {
      if (this.empname !== "" && this.empname !== null) {
        this.current = 2;
      } else {
        this.current = 1;
      }
    } else {
      this.current--;
    }
  }
  agreeStart() {
    this.modalService.confirm({
      nzTitle:
        "Thank you for providing your consent for background verification. Click on OK to submit your data",
      nzContent: "",
      nzWidth: "500px",
      nzOnOk: () => this.approveapi(),
      nzOnCancel: () => {},
    });
  }
  agreeReject() {
    this.modalService.confirm({
      nzTitle:
        "Background verification is mandatory for employment with Federal Bank. Are you sure you don’t want to provide the consent for background verification ?",
      nzContent: "",
      nzWidth: "500px",
      nzOnOk: () => this.rejectapi(),
      nzOnCancel: () => {},
    });
  }
  getCandidateData(id) {
    this.dashboardService.getCandidateValues(id).subscribe((data) => {
   this. is_bgv_in_registration=data.is_bgv_in_registration;
      // college_name: "College of Engineering Chengannur"
      // correspondence_address: {streetname: "kjb", premisename: "jhb", pincode: 654651, district: "kjbjk", roomnumber: "kjb",…}
      // course: "BTech"
      // designation: "Python Developer"
      // dob: "04-06-1995"
      // emp_end_date: "2020-03-18"
      // emp_start_date: "2019-03-18"
      // employer_name: "Zappyhire"
      // father_name: ""
      // gender: "Female"
      // marital_status: "Married"
      // name: "MEHAR INTERN"
      // nationality: "Indian"
      // passout_year: "2020-03-18"
      // permenant_address: {streetname: "kjb", premisename: "jhb", pincode: 654651, district: "kjbjk", roomnumber: "kjb",…}
      // reason_leave: "Resignation"
      let dat = data;
      this.name = dat.name;
      this.al_email = dat.alternative_email;
      this.campusdata = dat.all_academics;

      this.campusdata.forEach((element) => {
        element["if_fulltime"] = "";
      });
      this.fatherName = dat.father_name;
      this.dob = dat.dob;
      this.gender = dat.gender;
      this.martialS = dat.marital_status;
      this.nationality = dat.nationality;
      this.pAddress =
        dat.permenant_address.roomnumber +
        ", " +
        dat.permenant_address.premisename +
        ", " +
        dat.permenant_address.streetname +
        ", " +
        dat.permenant_address.district +
        ", " +
        dat.permenant_address.pincode;
      //   // this.pLandmark=
      //   // this.pNumber=
      this.course = dat.course;
      this.jobid = data.job;
      this.yearPass = dat.passout_year;
      this.collegeName = dat.college_name;
      //this.unniname=dat.name;

      this.presentAddress.controls["room"].setValue(
        dat.correspondence_address.roomnumber,
      );

      this.presentAddress.controls["street"].setValue(
        dat.correspondence_address.streetname,
      );

      this.presentAddress.controls["pincode"].setValue(
        dat.correspondence_address.pincode,
      );
      this.presentAddress.controls["cphone"].setValue(
        dat.correspondence_address.mobile,
      );
      this.presentAddress.controls["alcontact"].setValue(
        dat.correspondence_address.alternate,
      );

      this.presentAddress.controls["stayDur"].setValue(
        dat.correspondence_address.periodofstay,
      );
      this.presentAddress.controls["landmark"].setValue(
        dat.correspondence_address.landmark,
      );
      this.presentAddress.controls["district"].setValue(
        dat.correspondence_address.district,
      );
      this.presentAddress.controls["state"].setValue(
        dat.correspondence_address.state,
      );
      this.presentAddress.controls["local"].setValue(
        dat.correspondence_address.premisename,
      );

      this.presentAddress.controls["pStay"].setValue(
        dat.permenant_address.periodofstay,
      );
      this.presentAddress.controls["pLandmark"].setValue(
        dat.permenant_address.landmark,
      );

      this.presentAddress.controls["pNumber"].setValue(
        dat.permenant_address.mobile,
      );
      this.presentAddress.controls["palNumber"].setValue(
        dat.permenant_address.alternate,
      );

      this.unniname = dat.university_name;

      this.employerForm.controls["empName"].setValue(dat.employer_name);
      this.employerForm.controls["empFrom"].setValue(dat.emp_start_date);
      this.employerForm.controls["empTo"].setValue(dat.emp_end_date);
      this.employerForm.controls["reasonLeaving"].setValue(dat.reason_leave);
      this.employerForm.controls["designation"].setValue(dat.designation);

      this.employerForm.controls["salary"].setValue(dat.last_salary);
      this.empname = dat.employer_name;
    });
  }

  patchCandidateData() {
    this.pdfn = true;
    this.campusdata.forEach((element) => {
      element["if_fulltime"] =
        element["if_fulltime"] === "regular" ? true : false;
    });

    let r1Addres = [];
    let r2Addres = [];
    let r3Addres = [];
    r1Addres.push({
      roomnumber: this.referalFormGroup.controls["r1roomnumber"].value.trim(),
      premisename: this.referalFormGroup.controls["r1premisename"].value.trim(),
      streetname: this.referalFormGroup.controls["r1streetname"].value.trim(),
      state: this.referalFormGroup.controls["r1state"].value.trim(),
      pincode: this.referalFormGroup.controls["r1pincode"].value,
      district: this.referalFormGroup.controls["r1district"].value.trim(),
    });

    r2Addres.push({
      roomnumber: this.referalFormGroup.controls["r2roomnumber"].value.trim(),
      premisename: this.referalFormGroup.controls["r2premisename"].value.trim(),
      streetname: this.referalFormGroup.controls["r2streetname"].value.trim(),
      state: this.referalFormGroup.controls["r2state"].value.trim(),
      pincode: this.referalFormGroup.controls["r2pincode"].value,
      district: this.referalFormGroup.controls["r2district"].value.trim(),
    });

    r3Addres.push({
      roomnumber: this.referalFormGroup.controls["r3roomnumber"].value.trim(),
      premisename: this.referalFormGroup.controls["r3premisename"].value.trim(),
      streetname: this.referalFormGroup.controls["r3streetname"].value.trim(),
      state: this.referalFormGroup.controls["r3state"].value.trim(),
      pincode: this.referalFormGroup.controls["r3pincode"].value,
      district: this.referalFormGroup.controls["r3district"].value.trim(),
    });
    this.dashboardService
      .patchCandidateValues(this.loginid, {
        all_academics: this.campusdata,
        alternative_email: this.al_email ? this.al_email : "",
        correspondence_address: [
          {
            state: this.presentAddress.controls["state"].value,
            pincode: this.presentAddress.controls["pincode"].value,
            district: this.presentAddress.controls["district"].value,
            roomnumber: this.presentAddress.controls["room"].value,
            streetname: this.presentAddress.controls["street"].value,
            premisename: this.presentAddress.controls["local"].value,
            landmark: this.presentAddress.controls["landmark"].value,
            periodofstay: this.presentAddress.controls["stayDur"].value,
            mobile: this.presentAddress.controls["cphone"].value,
            alternate: this.presentAddress.controls["alcontact"].value,
          },
        ],
        permanent_address_landmark:
          this.presentAddress.controls["pLandmark"].value,
        permanent_address_period: this.presentAddress.controls["pStay"].value,
        permanent_address_mobile: this.presentAddress.controls["pNumber"].value,
        permanent_address_alternate:
          this.presentAddress.controls["palNumber"].value,
        college_address: this.collegeAddress,
        university_name: this.unniname,
        university_address: this.unniAddress,
        if_fulltime: this.courseType === "regular" ? true : false,
        emp_id: this.employerForm.controls["empCode"].value,
        employer_address: this.employerForm.controls["empAdd"].value,
        dept_branch_office: this.employerForm.controls["department"].value,
        position_type: this.employerForm.controls["posType"].value,
        agency_details: this.employerForm.controls["agencyDetails"].value,
        last_salary: this.employerForm.controls["salary"].value,

        reference: {
          reference: [
            {
              referencename:
                this.referalFormGroup.controls["referencename1"].value.trim(),
              referencenumber:
                this.referalFormGroup.controls["referencenumber1"].value,
              referenceemail:
                this.referalFormGroup.controls["referenceemail1"].value.trim(),

              referenceaddress: r1Addres,
            },
            {
              referencename:
                this.referalFormGroup.controls["referencename2"].value.trim(),
              referencenumber:
                this.referalFormGroup.controls["referencenumber2"].value,
              referenceemail:
                this.referalFormGroup.controls["referenceemail2"].value.trim(),
              referenceaddress: r2Addres,
            },
            {
              referencename:
                this.referalFormGroup.controls["referencename3"].value.trim(),
              referencenumber:
                this.referalFormGroup.controls["referencenumber3"].value,
              referenceemail:
                this.referalFormGroup.controls["referenceemail3"].value.trim(),
              referenceaddress: r3Addres,
            },
          ],
        },
        hr_details: {
          name: this.employerForm.controls["hrName"].value,
          mobile: this.employerForm.controls["hrNumber"].value,
          email: this.employerForm.controls["hrEmail"].value,
        },
      })
      .subscribe(
        (data) => {
          if (this.is_latral) {
            if (data.is_payment_in_bgv_registration) {
              this.amount = data.total_amount;
              //  this.mid = this.paymentobject.results.mid;

              //  this.enc_data = this.paymentobject.results.enc_data;
              //  this.merchantRequest.nativeElement.value = this.enc_data;

              this.listofbills = data.amount_breakdown;

              this.globalConfig = (window as any).globalConfig;
              this.globalConfig.data = data.payload_data;
              this.payment = true;
            }
          }

          this.pdfn = false;
          this.offerletterProvisionModel.isVisible = true;
          this.offerletterProvisionModel.pdf = data;

          this.offerletterProvisionModel.pdf =
            this.sanitiser.bypassSecurityTrustResourceUrl(data);
          // college_name: "College of Engineering Chengannur"
          // correspondence_address: {streetname: "kjb", premisename: "jhb", pincode: 654651, district: "kjbjk", roomnumber: "kjb",…}
          // course: "BTech"
          // designation: "Python Developer"
          // dob: "04-06-1995"
          // emp_end_date: "2020-03-18"
          // emp_start_date: "2019-03-18"
          // employer_name: "Zappyhire"
          // father_name: ""23
          // gender: "Female"
          // marital_status: "Married"
          // name: "MEHAR INTERN"
          // nationality: "Indian"
          // passout_year: "2020-03-18"
          // permenant_address: {streetname: "kjb", premisename: "jhb", pincode: 654651, district: "kjbjk", roomnumber: "kjb",…}
          // reason_leave: "Resignation"
        },
        (err) => {
          this.message.error(err.Message);
        },
      );
  }

  approveapi() {
    if (this.is_bgv_in_registration==true) {
      if (this.payment) {
        this.paymentscreen = true;
      } else {
        this.message.success("Details Updated Sucessfully!", {
          nzDuration: 10000,
        });
        this.logout();
      }
    } else {
      this.dashboardService
        .approveValues(
          this.loginid,
          this.jobid,

          {
            status: "BVR",
            bgv_accepted_datetime: this.datePipe.transform(
              new Date(),
              "yyyy-MM-dd HH:mm:ss",
            ),
          },
        )
        .subscribe((data) => {
          this.message.success("Details Updated Sucessfully!", {
            nzDuration: 10000,
          });
          this.logout();
          this.offerletterProvisionModel.isVisible = false;
          // this.offerletterProvisionModel.pdf=data;
          // college_name: "College of Engineering Chengannur"
          // correspondence_address: {streetname: "kjb", premisename: "jhb", pincode: 654651, district: "kjbjk", roomnumber: "kjb",…}
          // course: "BTech"
          // designation: "Python Developer"
          // dob: "04-06-1995"
          // emp_end_date: "2020-03-18"
          // emp_start_date: "2019-03-18"
          // employer_name: "Zappyhire"
          // father_name: ""
          // gender: "Female"
          // marital_status: "Married"
          // name: "MEHAR INTERN"
          // nationality: "Indian"
          // passout_year: "2020-03-18"
          // permenant_address: {streetname: "kjb", premisename: "jhb", pincode: 654651, district: "kjbjk", roomnumber: "kjb",…}
          // reason_leave: "Resignation"
        });
    }
  }
  rejectapi() {
    this.dashboardService
      .approveValues(
        this.loginid,
        this.jobid,

        {
          status: "BVCR",
          bgv_rejected_datetime: this.datePipe.transform(
            new Date(),
            "yyyy-MM-dd HH:mm:ss",
          ),
        },
      )
      .subscribe((data) => {
        this.offerletterProvisionModel.isVisible = false;
        this.logout();
        // this.offerletterProvisionModel.pdf=data;
        // college_name: "College of Engineering Chengannur"
        // correspondence_address: {streetname: "kjb", premisename: "jhb", pincode: 654651, district: "kjbjk", roomnumber: "kjb",…}
        // course: "BTech"
        // designation: "Python Developer"
        // dob: "04-06-1995"
        // emp_end_date: "2020-03-18"
        // emp_start_date: "2019-03-18"
        // employer_name: "Zappyhire"
        // father_name: ""
        // gender: "Female"
        // marital_status: "Married"
        // name: "MEHAR INTERN"
        // nationality: "Indian"
        // passout_year: "2020-03-18"
        // permenant_address: {streetname: "kjb", premisename: "jhb", pincode: 654651, district: "kjbjk", roomnumber: "kjb",…}
        // reason_leave: "Resignation"
      });
  }

  logout() {
    this.authenticationService.logout().subscribe((response) => {
      localStorage.clear();
      this.router.navigate(["./login"]);
    });
  }

  checkacademics() {
    let bol = true;
    this.campusdata.forEach((element) => {
      if (
        element.if_fulltime === null ||
        element.if_fulltime === "" ||
        element.college_address == null ||
        element.college_address == ""
      ) {
        bol = false;
      }
    });

    return bol;
  }
  proceedtopay() {
    this.proceedtopayButton = false;
  }
}


